import ZIcon from './icon.vue'

ZIcon.install = function(app) {
  app.component(ZIcon.name, ZIcon)
}

export default ZIcon